import { c as _c } from "react/compiler-runtime";
import { forwardRef, useMemo, type ReactNode } from 'react';
import { type CopilotMessage, type CopilotMessageContentPart } from '../types';
import { StyledGridCopilotMessageCardContainer, StyledGridCopilotMessageCardContent, StyledSpanCopilotMessageAuthorName, StyledSpanCreatedAtDetails, StyledLoadingDots } from '../styles';
import Typography from '../../../Typography';
import Grid from '../../../Grid';
import { CopilotIcon } from '../../../icons/CopilotIcon';
import ThinkingSignaturesPart from './ThinkingSignaturesPart';
import { getThinkingWord } from '../utils';
interface CopilotMessageCardProps {
  message: CopilotMessage;
}
const CopilotMessageCard = forwardRef<HTMLDivElement, CopilotMessageCardProps>((t0, ref) => {
  const $ = _c(22);
  const {
    message
  } = t0;
  let t1;
  if ($[0] !== message.id) {
    t1 = getThinkingWord(message.id);
    $[0] = message.id;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const thinkingWord = t1;
  const t2 = message.isThinkingInProgress ?? false;
  let t3;
  if ($[2] !== t2) {
    t3 = <CopilotIcon isLoading={t2} />;
    $[2] = t2;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  let t4;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = {
      lineHeight: "20px",
      height: "20px"
    };
    $[4] = t4;
  } else {
    t4 = $[4];
  }
  const t5 = message.isThinkingInProgress === true ? thinkingWord : "Copilot";
  let t6;
  if ($[5] !== t5) {
    t6 = <StyledSpanCopilotMessageAuthorName>{t5}</StyledSpanCopilotMessageAuthorName>;
    $[5] = t5;
    $[6] = t6;
  } else {
    t6 = $[6];
  }
  let t7;
  if ($[7] !== message.createdAtString || $[8] !== message.isThinkingInProgress) {
    t7 = message.isThinkingInProgress === true ? <StyledLoadingDots /> : <StyledSpanCreatedAtDetails> • {message.createdAtString}</StyledSpanCreatedAtDetails>;
    $[7] = message.createdAtString;
    $[8] = message.isThinkingInProgress;
    $[9] = t7;
  } else {
    t7 = $[9];
  }
  let t8;
  if ($[10] !== t6 || $[11] !== t7) {
    t8 = <Typography variant="body3" style={t4}>{t6}{t7}</Typography>;
    $[10] = t6;
    $[11] = t7;
    $[12] = t8;
  } else {
    t8 = $[12];
  }
  let t9;
  if ($[13] !== t3 || $[14] !== t8) {
    t9 = <Grid display="flex" flexDirection="row" gap="8px" alignItems="center">{t3}{t8}</Grid>;
    $[13] = t3;
    $[14] = t8;
    $[15] = t9;
  } else {
    t9 = $[15];
  }
  let t10;
  if ($[16] !== message.contentParts) {
    t10 = message.contentParts.map((part, index) => <CopilotMessageContentPartRenderer key={part.id} part={part} isFollowedByNonThinkingContent={hasFollowingNonThinkingContent(message.contentParts, index)} />);
    $[16] = message.contentParts;
    $[17] = t10;
  } else {
    t10 = $[17];
  }
  let t11;
  if ($[18] !== ref || $[19] !== t10 || $[20] !== t9) {
    t11 = <StyledGridCopilotMessageCardContainer ref={ref}>{t9}{t10}</StyledGridCopilotMessageCardContainer>;
    $[18] = ref;
    $[19] = t10;
    $[20] = t9;
    $[21] = t11;
  } else {
    t11 = $[21];
  }
  return t11;
});
const hasFollowingNonThinkingContent = (contentParts: CopilotMessageContentPart[], index: number): boolean => contentParts.slice(index + 1).some(laterPart => laterPart.type !== 'thinkingSignatures');
const CopilotMessageContentPartRenderer = t0 => {
  const $ = _c(5);
  const {
    part,
    isFollowedByNonThinkingContent
  } = t0;
  if (part.type === "thinkingSignatures") {
    const t1 = part.isThinkingInProgress === true && !isFollowedByNonThinkingContent;
    let t2;
    if ($[0] !== part.thinkingSignatures || $[1] !== t1) {
      t2 = <ThinkingSignaturesPart thinkingSignatures={part.thinkingSignatures} isThinkingInProgress={t1} />;
      $[0] = part.thinkingSignatures;
      $[1] = t1;
      $[2] = t2;
    } else {
      t2 = $[2];
    }
    return t2;
  }
  let t1;
  if ($[3] !== part.content) {
    t1 = <StyledGridCopilotMessageCardContent>{part.content}</StyledGridCopilotMessageCardContent>;
    $[3] = part.content;
    $[4] = t1;
  } else {
    t1 = $[4];
  }
  return t1;
};
export default CopilotMessageCard;